import { IconButton } from "@mui/material";
import { PlusIcon, MinusIcon } from "@phosphor-icons/react";
import clsx from "clsx";

import { MAX_TRAVELLERS } from "@/utils/constants";

interface CounterProps {
  value: number;
  maxValue?: number;
  minValue?: number;
  minusButtonAriaLabel?: string;
  plusButtonAriaLabel?: string;
  onChange: (newValue: number) => void;
}

export default function CounterButton({
  value,
  maxValue = MAX_TRAVELLERS,
  minValue = 0,
  minusButtonAriaLabel,
  plusButtonAriaLabel,
  onChange,
}: CounterProps) {
  const minusDisabled = minValue != null ? value <= minValue : false;
  const plusDisabled = maxValue != null ? value >= maxValue : false;

  return (
    <div className="flex w-fit items-center gap-2 rounded-2xl border border-solid border-stroke-neutral-soft px-1 py-1.5">
      <IconButton
        onClick={() => onChange(Math.max(value - 1, minValue))}
        disabled={minusDisabled}
        type="button"
        aria-label={minusButtonAriaLabel ?? "-"}
      >
        <MinusIcon
          size={20}
          className={clsx({
            "fill-secondary": !minusDisabled,
            "fill-text-disabled-label": minusDisabled,
          })}
          weight="bold"
          aria-hidden
        />
      </IconButton>
      <span className="flex w-3 justify-center text-text-label">{value}</span>
      <IconButton
        onClick={() => onChange(Math.min(value + 1, maxValue))}
        disabled={plusDisabled}
        type="button"
        aria-label={plusButtonAriaLabel ?? "+"}
      >
        <PlusIcon
          size={20}
          className={clsx({
            "fill-secondary": !plusDisabled,
            "fill-text-disabled-label": plusDisabled,
          })}
          weight="bold"
          aria-hidden
        />
      </IconButton>
    </div>
  );
}
